function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg10N(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.52,
    height: 36.996,
    viewBox: "0 0 31.52 36.996",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "10n"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184503"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184502"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184498"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14447",
    d: "M268.8 191.332a4.542 4.542 0 0 0-4.485-3.513 4.667 4.667 0 0 0-2.856.966 8.127 8.127 0 0 0-7.261-4.349 8 8 0 0 0-8.026 6.8 5.4 5.4 0 0 0-4.328 5.2 5.452 5.452 0 0 0 5.537 5.33h19.811a5.452 5.452 0 0 0 5.537-5.33 5.379 5.379 0 0 0-3.929-5.104z",
    transform: "translate(-241.843 -176.151)",
    style: {
      fill: "#d32f2f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184623"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14526",
    d: "M3.546 10.362A5.282 5.282 0 0 1 0 8.99h.342A5.639 5.639 0 0 0 4.872 0a5.266 5.266 0 0 1-1.326 10.36z",
    transform: "rotate(105.01 14.649 13.537)",
    style: {
      fill: "#283593"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14527",
    d: "M3.4.709a.15.15 0 0 0 .1-.076L3.856 0 4.2.633a.15.15 0 0 0 .1.076l.709.136-.493.527a.144.144 0 0 0-.04.122l.09.715-.647-.309a.144.144 0 0 0-.128 0l-.655.306.09-.715a.148.148 0 0 0-.038-.122l-.5-.527zM.3 3.652l.058-.463a.148.148 0 0 0-.04-.122L0 2.727l.457-.084a.156.156 0 0 0 .1-.076l.224-.4.226.4a.148.148 0 0 0 .1.076l.457.086-.324.338a.154.154 0 0 0-.04.122l.058.463-.422-.2a.154.154 0 0 0-.128 0zm3.883 1.24a.15.15 0 0 0-.038.122l.058.461-.422-.2a.148.148 0 0 0-.064-.014.142.142 0 0 0-.064.014l-.422.2.058-.461a.152.152 0 0 0-.04-.122l-.32-.34.457-.088a.152.152 0 0 0 .1-.074l.226-.41.224.41a.152.152 0 0 0 .1.074l.457.088z",
    transform: "rotate(105.01 14.925 12.578)",
    style: {
      fill: "#283593"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184501"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184499"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14448",
    d: "M266.045 191.343a6.419 6.419 0 0 1 5.2-2.776.385.385 0 0 0 0-.769 7.233 7.233 0 0 0-5.864 3.156c-.285.406.382.791.664.388z",
    transform: "translate(-258.913 -178.597)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184500"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14449",
    d: "M246.381 218.258a4.178 4.178 0 0 1 1.959-3.481c.416-.266.031-.932-.388-.664a4.973 4.973 0 0 0-2.34 4.145.385.385 0 0 0 .769 0z",
    transform: "translate(-244.584 -197.692)",
    style: {
      fill: "#fff"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184514"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184505"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184504"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14451",
    d: "m277.166 252.3 2 3.153c.234.369.824.028.589-.344l-2-3.153c-.234-.369-.824-.028-.589.344z",
    transform: "translate(-267.496 -225.143)",
    style: {
      fill: "#283593"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184507"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184506"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14452",
    d: "m293.529 255.48 2 3.153c.234.369.824.028.589-.344l-2-3.153c-.234-.369-.824-.028-.589.344z",
    transform: "translate(-279.398 -227.46)",
    style: {
      fill: "#283593"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184509"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184508"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14453",
    d: "m289.43 273.07 2 3.153c.234.369.824.028.589-.344l-2-3.153c-.234-.369-.824-.028-.589.344z",
    transform: "translate(-276.417 -240.254)",
    style: {
      fill: "#283593"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184511"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184510"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14454",
    d: "m274.476 267.736 2 3.153c.234.369.824.028.589-.344l-2-3.153c-.234-.369-.824-.028-.589.344z",
    transform: "translate(-265.539 -236.374)",
    style: {
      fill: "#283593"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184513"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184512"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14455",
    d: "m305.793 276.255 2 3.153c.234.369.824.028.589-.344l-2-3.153c-.234-.369-.824-.028-.589.344z",
    transform: "translate(-288.318 -242.57)",
    style: {
      fill: "#283593"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg10N);
export default __webpack_public_path__ + "static/media/10N.6d0fcb02d60007727ea85726bc099eaf.svg";
export { ForwardRef as ReactComponent };